module.exports = __webpack_public_path__ + "img/close.6bbf6f47.svg";